<template>
  <div class="good-item">
    <div class="good-card">
      <div class="good-img">
        <a @click="goodsDetails(msg.productId)">
          <img :src="imgUrl" :alt="msg.productName">
        </a>
        <div class="img-actions">
          <a class="act-btn" @click="goodsDetails(msg.productId)">查看详情</a>
          <a class="act-btn primary" @click="goodsDetails(msg.productId)">立即购买</a>
        </div>
      </div>
      <div class="good-info">
        <div class="good-price">
          <span class="symbol">￥</span><span class="integer">{{priceInt}}</span><span class="decimal">.{{priceDec}}</span>
        </div>
        <div class="good-title" v-html="msg.itemTitle">{{msg.itemTitle}}</div>
        <div class="sub-title ellipsis" v-if="msg.subTitle">{{msg.subTitle}}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import YButton from '/components/YButton'
  import { addCart } from '/api/goods.js'
  import { mapMutations, mapState } from 'vuex'
  import { getStore } from '/utils/storage'
  export default {
    props: {
      msg: {
        salePrice: 0
      }
    },
    data () {
      return {
        selectParams:{
          search: '',
        	sort: 'weigh',
        	order: 'asc',
        	page: 1,
        	filter: {},
        	op: {},
          open:false,
        },
      }
    },
    methods: {
      openDialog(){
        this.open = true
        this.$emit('openDialog',this.open)
      },
      goodsDetails (id) {
        const url = this.$router.resolve({
          name: 'productDetails',
          query: { data: JSON.stringify(this.msg) }
        }).href;

        // 使用 window.open 在新标签页打开 URL，而不在当前标签页跳转
        window.open(url, '_blank');
      },
      addCart (id, price, name, img) {
        setTimeout(()=>{
          if (this.cart.showMoveImg) {
            this.$store.commit('cart/addanimation',{moveShow: false})
          }
        },2000)
        if (!this.cart.showMoveImg) {     // 动画是否在运动
          if (this.user.isLogin) { // 登录了 直接存在用户名下
              addCart({userId: getStore('userId'), productId: id, productNum: 1}).then(res => {
              // 并不重新请求数据
              this.$store.commit('cart/addcart',{productId: id, salePrice: price, productName: name, productImg: img})
            })
          } else { // 未登录 vuex
            this.$store.commit('cart/addcart',{productId: id, salePrice: price, productName: name, productImg: img})
          }
          // 加入购物车动画
          var dom = event.target
          // 获取点击的坐标
          let elLeft = dom.getBoundingClientRect().left + (dom.offsetWidth / 2)
          let elTop = dom.getBoundingClientRect().top + (dom.offsetHeight / 2)
          // 需要触发
          this.$store.commit('cart/addanimation',{moveShow: true, elLeft: elLeft, elTop: elTop, img: img})
          if (!this.cart.showCart) {
            this.$store.commit('cart/showcart',{showCart: true})
          }
        }
      },
    },
    computed: {
      ...mapState(['user', 'cart']),
      imgUrl () {
        return this.msg.itemImage || '';
      },
      priceInt () {
        return Math.floor(Number(this.msg.price) || 0);
      },
      priceDec () {
        let num = Number(this.msg.price) || 0;
        return num.toFixed(2).split('.')[1];
      }
    },
    components: {
      YButton
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../assets/style/mixin";
  @import "../assets/style/theme";

  .good-item {
    width: 100%;
  }

  .good-card {
    position: relative;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    transition: all 0.3s ease;
    height: 100%;
    display: flex;
    flex-direction: column;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);

      .img-actions {
        opacity: 1;
      }
    }
  }

  // 图片区：正方形、白底，悬停时浮现操作按钮（京东风格）
  .good-img {
    position: relative;
    width: 100%;
    padding-top: 100%; // 1:1 正方形
    background: #fff;
    overflow: hidden;

    > a {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      display: block;
      transition: transform 0.3s ease;
    }
  }

  .good-card:hover .good-img img {
    transform: scale(1.04);
  }

  // 悬停浮现的操作按钮层（半透明遮罩）
  .img-actions {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    gap: 8px;
    padding: 10px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.45));
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 2;

    .act-btn {
      flex: 1;
      text-align: center;
      font-size: 13px;
      line-height: 32px;
      border-radius: 16px;
      background: rgba(255, 255, 255, 0.95);
      color: #333;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background: #fff;
        color: #e4393c;
      }

      &.primary {
        background: #e4393c;
        color: #fff;

        &:hover {
          background: #f0494c;
          color: #fff;
        }
      }
    }
  }

  // 信息区：价格突出 + 标题左对齐两行截断（京东风格）
  .good-info {
    padding: 12px 14px 16px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .good-price {
    color: #e4393c;
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1;
    margin-bottom: 8px;

    .symbol {
      font-size: 13px;
      font-weight: 600;
    }

    .integer {
      font-size: 22px;
      font-weight: 700;
    }

    .decimal {
      font-size: 13px;
      font-weight: 600;
    }
  }

  .good-title {
    font-size: 14px;
    font-weight: 400;
    color: #333;
    line-height: 1.5;
    text-align: left;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    height: 42px;
    transition: color 0.2s ease;
  }

  .good-card:hover .good-title {
    color: #e4393c;
  }

  .sub-title {
    margin-top: 6px;
    font-size: 12px;
    font-weight: 400;
    color: #999;
    text-align: left;
    line-height: 1.4;
  }
</style>



// WEBPACK FOOTER //
// mallGoods.vue?039abceb